import { useApi } from './useApi';

export function useAuth() {
  const { postData, data, error, loading } = useApi();

  const loginApi = async (credentials) => {
    try {
      await postData('/api/user/login', credentials);

      return {
        success: true,
        data: data.value
      };
    } catch (err) {
      return {
        success: false,
        error: error.value || 'Lỗi kết nối'
      };
    }
  };

    const createUserApi = async (credentials) => {
        try {
            await postData('/api/user/register', credentials);

            return {
                success: true,
                data: data.value
            };
        } catch (err) {
            return {
                success: false,
                error: error.value || 'Lỗi kết nối'
            };
        }
    };

  return { loginApi, loading, createUserApi };
}
